import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { AUDIT_LOG_VIEW } from "../../auditPermissions";
import type { AuditRouteFactory } from "./auditRouteContext";

const AuditLogListScreen = lazyRouteComponent(
  () => import("../AuditLogListScreen"),
  "AuditLogListScreen",
);

export const createAuditLogRoutes: AuditRouteFactory = ({ context }) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: context.basePath,
    beforeLoad: requirePermission([AUDIT_LOG_VIEW]),
    component: AuditLogListScreen,
  }),
];
